import { useLocation, useNavigate } from "react-router-dom";

import { useUserContext } from "../../context/User";
import { authRedirectKey, setInStorage } from "../../services/storage";
import Button from "../Button";

const AdoptLogin = () => {
  const { user } = useUserContext();
  const location = useLocation();
  const navigate = useNavigate();

  const navigateToLogin = () => {
    setInStorage(authRedirectKey, location.pathname);
    return navigate("/login");
  };

  return (
    <div className="flex max-w-xl flex-col gap-6 text-center">
      {user.accessToken ? (
        <div>You are already logged in.</div>
      ) : (
        <>
          <div>
            To keep everyone safe – especially our dogs – we ask you to sign in. It only takes a
            moment and lets us create your account securely.
          </div>
          <div className="flex justify-center">
            <Button title="Login" theme="dark" onClick={navigateToLogin} />
          </div>
        </>
      )}
    </div>
  );
};

export default AdoptLogin;
